import { useState } from "react";
import imgevent from "../../assets/images/imgevent.webp";
import { MdChevronRight } from "react-icons/md";
import PaginationPC from "./PaginitionPc";

export default function TabComponent() {
  const [activeTab1, setActiveTab1] = useState("Tin mới nhất");

  const renderContent = () => {
    switch (activeTab1) {
      case "Tin mới nhất":
        return (
          <div className="grid grid-cols-3 gap-5">
            <div className=" shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] relative ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  Lorem ipsum dolor sit amet.
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
                <a href="new-detail">
                  <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
            <div className=" shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] relative ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  Lorem ipsum dolor sit amet.
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
                <a href="new-detail">
                  <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
            <div className=" shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] relative ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  Lorem ipsum dolor sit amet.
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
                <a href="new-detail">
                  <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
            <div className=" shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] relative ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  Lorem ipsum dolor sit amet.
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
                <a href="new-detail">
                  <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
            <div className=" shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] relative ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  Lorem ipsum dolor sit amet.
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
                <a href="new-detail">
                  <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
            <div className=" shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] relative ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  Lorem ipsum dolor sit amet.
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
                <a href="new-detail">
                  <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </div>
        );
      case "Tin tức":
        return <p>Content for Tin tức</p>;
      case "Sự kiện":
        return <p>Content for Sự kiện</p>;
      default:
        return null;
    }
  };

  return (
    <div className="w-full p-3">
      <div className="h-[59px] rounded-[40px] bg-white shadow-custom border border-solid border-gray-200 flex items-center gap-6 px-3">
        {/* Tin mới nhất tab */}
        <div
          onClick={() => setActiveTab1("Tin mới nhất")}
          className={`cursor-pointer ${
            activeTab1 === "Tin mới nhất"
              ? "text-blue-500 font-semibold"
              : "text-gray-700"
          }`}
        >
          <p>Tin mới nhất</p>
        </div>

        {/* Divider */}
        <div className="h-14 w-[1px] bg-gray-300"></div>

        {/* Tin tức tab */}
        <div
          onClick={() => setActiveTab1("Tin tức")}
          className={`cursor-pointer ${
            activeTab1 === "Tin tức"
              ? "text-blue-500 font-semibold"
              : "text-gray-700"
          }`}
        >
          <p>Tin tức</p>
        </div>

        {/* Divider */}
        <div className="h-14 w-[1px] bg-gray-300"></div>

        {/* Sự kiện tab */}
        <div
          onClick={() => setActiveTab1("Sự kiện")}
          className={`cursor-pointer ${
            activeTab1 === "Sự kiện"
              ? "text-blue-500 font-semibold"
              : "text-gray-700"
          }`}
        >
          <p>Sự kiện</p>
        </div>
      </div>

      {/* Tab content */}
      <div className="mt-4 p-4">{renderContent()}</div>
      <PaginationPC />
    </div>
  );
}
